/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copiar'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nombre'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Abril',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Diciembre',
    FILTER_MONTH_FEB: 'Febrero',
    FILTER_MONTH_JAN: 'Enero',
    FILTER_MONTH_JUL: 'Julio',
    FILTER_MONTH_JUN: 'Junio',
    FILTER_MONTH_MAR: 'Marzo',
    FILTER_MONTH_MAY: 'Mayo',
    FILTER_MONTH_NOV: 'Noviembre',
    FILTER_MONTH_OCT: 'Octubre',
    FILTER_MONTH_SEP: 'Septiembre',
    GENERATE_HASHTAG: 'Generar hashtag',
    GENERATE_LINK: 'Generar enlace',
    GENERATED_HASHTAG: 'Hashtag generado',
    GENERATED_LINK: 'Enlace generado',
    MONTH: 'Mes',
    NAME: 'Nombre',
    YEAR: 'Año'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Sin productos',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Cambia los criterios de búsqueda'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag copiado',
    LINK_COPIED: 'Enlace copiado'
  },
  TOOLTIP: {
    MONTH: 'Mes',
    NAME: 'Nombre',
    YEAR: 'Año'
  }
};
